import ValueObject from "../../shared/domain/ValueObject";
import { RuleTypeEnum } from "./RuleType";
import { WebCategoryRuleValue, WebCategoryRuleValuePrimitive } from "./ruleValue/WebCategoryRuleValue";
import { WebHostnameRuleValue, WebHostnameRuleValuePrimitive } from "./ruleValue/WebHostnameRuleValue";
import { WebUrlRuleValue, WebUrlRuleValuePrimitive } from "./ruleValue/WebUrlRuleValue";
import { YoutubeChannelRuleValue, YoutubeChannelRuleValuePrimitive } from "./ruleValue/YoutubeChannelRuleValue";
import { YoutubeTopicRuleValue, YoutubeTopicRuleValuePrimitive } from "./ruleValue/YoutubeTopicRuleValue";
import { YoutubeVideoRuleValue, YoutubeVideoRuleValuePrimitive } from "./ruleValue/YoutubeVideoRuleValue";

export interface RuleValue<TRuleType extends RuleTypeLiteral = RuleTypeLiteral> extends ValueObject<RuleValuePrimitiveMap[TRuleType]> {
    getConflictKey(): string;
    conflictsWith(other: this): boolean;
    merge?(other: this): void;
    resolveTie(other: this): TieWinner;
}

export type TieWinner = "self" | "other";

type RuleValueConstructor<T extends RuleTypeLiteral> = new (value: RuleValuePrimitiveMap[T]) => RuleValue<T>;

export const RuleValueMap: { [K in RuleTypeLiteral]: RuleValueConstructor<K> } = {
    [RuleTypeEnum.YOUTUBE_TOPIC]: YoutubeTopicRuleValue,
    [RuleTypeEnum.YOUTUBE_VIDEO]: YoutubeVideoRuleValue,
    [RuleTypeEnum.YOUTUBE_CHANNEL]: YoutubeChannelRuleValue,
    [RuleTypeEnum.WEB_CATEGORY]: WebCategoryRuleValue,
    [RuleTypeEnum.WEB_HOSTNAME]: WebHostnameRuleValue,
    [RuleTypeEnum.WEB_URL]: WebUrlRuleValue,
};

export type RuleValuePrimitiveMap = {
    [RuleTypeEnum.YOUTUBE_TOPIC]: YoutubeTopicRuleValuePrimitive,
    [RuleTypeEnum.YOUTUBE_VIDEO]: YoutubeVideoRuleValuePrimitive,
    [RuleTypeEnum.YOUTUBE_CHANNEL]: YoutubeChannelRuleValuePrimitive,
    [RuleTypeEnum.WEB_CATEGORY]: WebCategoryRuleValuePrimitive,
    [RuleTypeEnum.WEB_HOSTNAME]: WebHostnameRuleValuePrimitive,
    [RuleTypeEnum.WEB_URL]: WebUrlRuleValuePrimitive,
};

export type RuleTypeLiteral = keyof RuleValuePrimitiveMap;

export const PUBLIC_RULE_TYPES = [
    RuleTypeEnum.YOUTUBE_TOPIC,
    RuleTypeEnum.YOUTUBE_VIDEO,
    RuleTypeEnum.YOUTUBE_CHANNEL,
    RuleTypeEnum.WEB_HOSTNAME,
    RuleTypeEnum.WEB_URL,
] as const;

export type PublicRuleTypeLiteral = (typeof PUBLIC_RULE_TYPES)[number];

